module.exports = __webpack_public_path__ + "static/fig5-f1e798cf7c2e2343ccb0a28f4b59965b.jpg";